import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import "./blogdetails.css";
import { Spin } from "antd";
import BreadcrumbBanner from "../components/BreadcrumbBanner";
import SeoHelmet from "../Seo/SeoHelmet";

const BlogDetail = () => {
  const { slug } = useParams();
  const [blog, setBlog] = useState(null);
  const [recentBlogs, setRecentBlogs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchBlog = async () => {
      try {
        const res = await axios.get(
          "https://cafemandhurah.mandurahcafe.com.au/api/blogs"
        );
        const blogs = res.data?.data || [];

        // ✅ Filter blogs with is_active: true
        const activeBlogs = blogs.filter((blog) => blog.is_active === true);

        // ✅ Find current blog
        const found = activeBlogs.find((blog) => blog.slug === slug);

        if (found) {
          setBlog(found);
        } else {
          setError("Blog not found.");
        }

        // ✅ Get 5 most recent active blogs excluding the current one
        const recent = activeBlogs
          .filter((blog) => blog.slug !== slug)
          .slice(0, 5);

        setRecentBlogs(recent);
      } catch (err) {
        console.error("Error fetching blog details:", err);
        setError("Failed to load blog details.");
      } finally {
        setLoading(false);
      }
    };

    fetchBlog();
  }, [slug]);

  if (loading)
    return (
     <div className="blog-loading">
  <Spin size="large" />
</div>

    );
  if (error) return <div className="blog-error">{error}</div>;

  return (
    <>
      <SeoHelmet page="blogdetails" />
      <BreadcrumbBanner
        title={blog?.title || "Blog Details"}
        backgroundImage="/Images/banner-about.jpg"
      />

      <div className="blog-detail-layout">
        <div className="blog-detail-container">
          <p className="blog-meta">
            <strong>Date:</strong>{" "}
            {new Date(blog.created_at).toLocaleDateString()} |{" "}
            <strong>Category:</strong> {blog.category} |{" "}
            <strong>Estimated Read Time:</strong> {blog.reading_time}
          </p>

          <div
            className="blog-detail-content"
            dangerouslySetInnerHTML={{ __html: blog.content }}
          />

          {blog.author && (
            <div className="author-section">
              <img
                src={blog.author?.image}
                alt={blog.author?.name}
                className="author-image"
                loading="lazy"
              />
              <div className="author-details">
                <h3>{blog.author?.name}</h3>
                <p>{blog.author?.description}</p>
              </div>
            </div>
          )}

          {blog.tags && (
            <div className="blog-tags">
              {blog.tags.split(",").map((tag, i) => (
                <span key={i} className="tag">
                  {tag.trim()}
                </span>
              ))}
            </div>
          )}
        </div>

        <div className="blog-sidebar">
          <h3>Recent Blogs</h3>
          <ul>
            {recentBlogs.map((b) => (
              <li key={b.id}>
                <a href={`/informative-blog/${b.slug}`}>{b.title}</a>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </>
  );
};

export default BlogDetail;
